import React from "react";
import { checkOutlineIcon, redHelpIcon, sendIcon, timeIcon } from "utils/data";
import { InputFieldComponent } from "./form/input_field";

export const DataInsightFormSection = () => {
  return (
    <section className="p-4 border border-secondary rounded-4 bg-secondary bg-opacity-10">
      <div className="d-flex align-items-center gap-3 mb-4">
        <div>
          <img
            src={redHelpIcon}
            alt="Help Icon"
            width={48}
            height={48}
            className="rounded-circle img-fluid"
          />
        </div>
        <div className="flex-fill">
          <h6 className="fw-medium mb-0 text-dark">Data Insights </h6>
          <div className="d-flex align-items-start gap-2">
            <img
              src={timeIcon}
              width={16}
              height={16}
              alt="Time Icon"
              className="mt-1"
            />
            <p className="m-0">Response Time : 1 min</p>
          </div>
        </div>
      </div>
      <h4 className="text-dark mb-3 fw-medium">What would you like to know?</h4>
      <InputFieldComponent
        placeholder="Type a request or question in plain english"
        className="bg-transparent border-secondary mb-3"
        sufixIcon={<img src={sendIcon} alt="Help Icon" />}
        handleSufixIconClick={() => {}}
        onChange={() => {}}
      />
      <div className="d-flex align-items-start gap-2">
        <img
          src={checkOutlineIcon}
          width={16}
          height={16}
          alt="Check Icon"
          className="mt-1"
        />

        <p className="m-0">Ask a humn (open Ticket)</p>
      </div>
    </section>
  );
};
